import React, { type FC } from 'react';
import { useToolNavigationActiveModuleProvider } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationActiveModuleProvider';
import { ToolNavigationCollapsedItem } from './ToolNavigationCollapsedItem';
import { PrimaryNavigationItem } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/types';
import classes from '../styles/index.module.css';

type ToolNavigationCollapsedListProps = {
	items: PrimaryNavigationItem[];
};

export const ToolNavigationCollapsedList: FC<ToolNavigationCollapsedListProps> = ({ items }) => {
	const activePageTypeId = useToolNavigationActiveModuleProvider();

	return (
		<div className={classes.toolNavigationCollapsedList}>
			{items.map((item) => {
				// const isActive = activeModule?.moduleName === item.moduleName;
				const isActive =
					activePageTypeId === item.pageTypeId ||
					item.childNavigationItems.some((i) => i.pageTypeId === activePageTypeId);

				return (
					<ToolNavigationCollapsedItem
						key={item.pageTypeId}
						title={item.title}
						url={item.url}
						moduleName={item.moduleName}
						childNavigationItems={item.childNavigationItems}
						isActive={isActive}
						pageTypeId={item.pageTypeId}
					/>
				);
			})}
		</div>
	);
};
